export class ReinitializePayload {
  jurisdictionId?: number;
}
